import React, { InputHTMLAttributes } from 'react';

import Input from '../../Atoms/Input';

import { Field, FieldLabel } from './styles';

type PaymentFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  customWidth?: string;
};

/*
 * Campo de pagamento com rotulo visivel.
 *
 * O PORQUE: estes campos eram rotulados so por `placeholder`, que desaparece
 * assim que o usuario digita. Num formulario de pagamento isso e defeito
 * funcional — depois de preencher, nao havia como distinguir "Data de
 * validade" de "CVV". E o mesmo achado do Perfil, com gatilho diferente: la o
 * campo nascia preenchido, aqui e o proprio ato de digitar que apaga o nome.
 *
 * O rotulo e DERIVADO do placeholder de proposito. Um <Field> escrito a mao em
 * cada um dos 48 campos permitiria que o texto visivel e o nome acessivel
 * divergissem com o tempo; aqui existe uma fonte so.
 *
 * O <span> nao e um segundo <label htmlFor>: o atomo Input ja registra o
 * rotulo acessivel oculto a partir do placeholder, e dois <label> apontando
 * para o mesmo campo tem leitura inconsistente entre leitores de tela.
 */
const PaymentField: React.FC<PaymentFieldProps> = ({ placeholder, ...rest }) => (
  <Field>
    {placeholder ? <FieldLabel>{placeholder}</FieldLabel> : null}
    <Input placeholder={placeholder} {...rest} customWidth="100%" />
  </Field>
);

export default PaymentField;
